<template>
	<div class="color_picker">
		<el-slider v-model="colorPicking" :min="0" :max="1530" class="slider3" @input="colorSliderChange(colorPicking)" @change="colorPickingChange(colorPicking)"></el-slider>
        <div class="color-svpanel" :style="{'background-color': background}" ref="colorSvpanel">
            <div class="color-svpanel__white"></div>
            <div class="color-svpanel__black"></div>
            <div class="color-svpanel__cursor" :style="{top:svpanelTop+'px',left:svpanelLeft+'px'}"></div>
        </div>
        <div class="rgb_box">
            <div class="r">
                <span class="laber">R:</span>
                <span class="val">{{colorSliderR}}</span>
            </div>
            <div class="g">
                <span class="laber">G:</span>
                <span class="val">{{colorSliderG}}</span>
            </div>
            <div class="b">
                <span class="laber">B:</span>
                <span class="val">{{colorSliderB}}</span>
            </div>
        </div>
	</div>
</template>

<script type="text/javascript">
    import { mapGetters } from 'vuex'
    import Color from '../api/color'
	export default {
        name: 'colorPicker',
        data () {
			const color = new Color({
				enableAlpha: false,
				format: 'rgb',
				// format: hsl / hsv / hex / rgb,
			});
			return {
				color,
				colorPicking:0,

				background:'hsl(0, 100%, 50%)',

				colorSliderR:0,
				colorSliderG:0,
				colorSliderB:0,

				svpanelTop:0,
				svpanelLeft:0,

				hue_:0,
				isDragging:false,
			}
        },
		props: {
			colorValueChange: {
				type: Function,
				default: null
			},
			colorChange: {
				type: Function,
				default: null
			},
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
            }),
			colorValue() {
				const hue = this.color.get('hue');
				const value = this.color.get('value');
				const saturation = this.color.get('saturation');
				return { hue, value, saturation};
			}
        },
        mounted(){
            this.draggable(this.$refs.colorSvpanel, {
                drag: (event) => {
                    this.handleDrag(event);
                },
                end: (event) => {
                    this.handleDrag(event);
                }
            });
        },
        methods:{
			colorPickingChange(){
				this.colorChange(false,this.colorSliderR,this.colorSliderG,this.colorSliderB);
			},
			setColorValue(value){
				this.color.fromString(value);
				console.log(this.color,this.color.get('hue'),value)
			},
			update(){
				const saturation = this.color.get('saturation');
				const value = this.color.get('value');

				const el = this.$refs.colorSvpanel;
				let { clientWidth: width, clientHeight: height } = el;
				// console.log(el,width,height)
				this.svpanelLeft = saturation * width / 100;
				this.svpanelTop = (100 - value) * height / 100;

				this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
				let colorValue = this.color.value.split('(')[1];
				this.colorSliderR = parseInt(colorValue.split(',')[0]);
				this.colorSliderG = parseInt(colorValue.split(',')[1]);
				this.colorSliderB = parseInt(colorValue.split(',')[2]);
				this.colorValueChange(this.colorSliderR,this.colorSliderG,this.colorSliderB);
				this.colorPicking = Math.round(this.color.get('hue') * 4.25);
				
				// console.log(this.cursorLeft,this.cursorTop)
			},
            colorSliderChange(val){
                this.hue_ = Math.round(val/4.25);
                this.color.set('hue', this.hue_);
                this.colorSvpanelVal = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
            },
            draggable(element, options) {
                let this_ = this;
				this.colorChange(true,this.colorSliderR,this.colorSliderG,this.colorSliderB);
                // if (Vue.prototype.$isServer) return;
                const moveFn = function (event) {
                    if (options.drag) {
                        options.drag(event);
                    }
                };
                const upFn = function (event) {
                    document.removeEventListener('mousemove', moveFn);
                    document.removeEventListener('mouseup', upFn);
                    document.onselectstart = null;
                    document.ondragstart = null;

                    this_.isDragging = false;

                    if (options.end) {
                        options.end(event);
                    }
                };
                element.addEventListener('mousedown', function (event) {
                    if (this_.isDragging) return;
                    document.onselectstart = function () { return false; };
                    document.ondragstart = function () { return false; };

                    document.addEventListener('mousemove', moveFn);
                    document.addEventListener('mouseup', upFn);
                    this_.isDragging = true;

                    if (options.start) {
                        options.start(event);
                    }
                });
            },
            handleDrag(event) {
                const container = this.$refs.colorSvpanel
                // const el = this.$el;
                const rect = container.getBoundingClientRect();

                let left = event.clientX - rect.left;
                let top = event.clientY - rect.top;
                left = Math.max(0, left);
                left = Math.min(left, rect.width);

                top = Math.max(0, top);
                top = Math.min(top, rect.height);

                this.svpanelLeft = left;
                this.svpanelTop = top;
				this.color.set({
					saturation: left / rect.width * 100,
					value: 100 - top / rect.height * 100
				});
				// console.log(left / rect.width * 100)
            },
        },
		watch: {
			colorValue() {
				this.update();
			},
			isDragging(){
				// console.log(this.isDragging)
				this.colorChange(this.isDragging,this.colorSliderR,this.colorSliderG,this.colorSliderB);
			}
		},

    }

</script>

<style type="text/css" lang="less">
	.color_picker{
        .slider3{
            .el-slider__runway{
                background: linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);
            }
            .el-slider__bar{
                background-color:rgba(0,0,0,0);
            }
        }
        .color-svpanel{
            margin: 0 auto;
            width: 100%;
            height: 7.5rem;
            position: relative;
            .color-svpanel__white{
                position: absolute;
                top: 0;left:0;right:0;bottom:0;
                background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0));
            }
            .color-svpanel__black{
                position: absolute;
                top: 0;left:0;right:0;bottom:0;
                background:linear-gradient(0deg,#000,transparent);
            }
            .color-svpanel__cursor{
                position: absolute;
                // cursor: pointer;
                width: 0.8rem;
                height: 0.8rem;
                box-shadow: 0 0 0 0.05rem rgba(0,0,0,0.4),;
                border: 0.15rem solid #FFFFFF;
                border-radius: 50%;
                transform: translate(-0.4rem,-0.4rem);
            }
        }
        .rgb_box{
            width: 100%;height: 2rem;line-height: 2rem;
            display: flex;
            background: #F6F8FA;
            border: 1px solid #EBEFF2;
            border-radius: 0 0 0.3rem 0.3rem;
            .leber{
                font-family: AlibabaPuHuiTiR;
                font-size: 1rem;
                color: #333333;
            }
            .r,.b,.g{
                display: flex;
                justify-content: space-between;
                flex:1;
                padding: 0 1rem;
            }
        }
    }
</style>